var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 28,
      height: 28,
      viewBox: "0 0 28 28",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M17.15 4.66663C18.3002 4.66663 19.25 5.6164 19.25 6.76663V7.81663H22.4C23.5502 7.81663 24.5 8.7664 24.5 9.91663V21.4666C24.5 22.6169 23.5502 23.5666 22.4 23.5666H5.6C4.44977 23.5666 3.5 22.6169 3.5 21.4666V9.91663C3.5 8.7664 4.44977 7.81663 5.6 7.81663H8.75V6.76663C8.75 5.6164 9.69977 4.66663 10.85 4.66663H17.15ZM17.15 6.76663H10.85V7.81663C10.85 8.96685 9.90023 9.91663 8.75 9.91663H5.6V21.4666H22.4V9.91663H19.25C18.0998 9.91663 17.15 8.96685 17.15 7.81663V6.76663ZM14 10.9666C16.3072 10.9666 18.2 12.8595 18.2 15.1666C18.2 17.4738 16.3072 19.3666 14 19.3666C11.6928 19.3666 9.8 17.4738 9.8 15.1666C9.8 12.8595 11.6928 10.9666 14 10.9666ZM7.7 10.9666C7.97848 10.9666 8.24555 11.0773 8.44246 11.2742C8.63938 11.4711 8.75 11.7381 8.75 12.0166C8.75 12.2951 8.63938 12.5622 8.44246 12.7591C8.24555 12.956 7.97848 13.0666 7.7 13.0666C7.42152 13.0666 7.15445 12.956 6.95754 12.7591C6.76063 12.5622 6.65 12.2951 6.65 12.0166C6.65 11.7381 6.76063 11.4711 6.95754 11.2742C7.15445 11.0773 7.42152 10.9666 7.7 10.9666ZM14 13.0666C12.8278 13.0666 11.9 13.9944 11.9 15.1666C11.9 16.3389 12.8278 17.2666 14 17.2666C15.1722 17.2666 16.1 16.3389 16.1 15.1666C16.1 13.9944 15.1722 13.0666 14 13.0666Z",
      fill: "#041F47"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgCamera, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/camera.cd63b7b8.svg";
export { ForwardRef as ReactComponent };